module.exports = new __parcel__URL__("shop_resources_button.cf7c9432.png").toString();